import {Component, OnDestroy, OnInit} from '@angular/core';
import { NodeBuilder} from '../../../../../../../shared/models';
import {NODE_TYPE, OptOut} from './opt-out';
import { required } from '../../../../../../../shared/utils';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-opt-out',
  templateUrl: './opt-out.component.html',
  styleUrls: ['./opt-out.component.scss']
})
export class OptOutComponent extends NodeBuilder implements OnInit, OnDestroy {

  optOut: OptOut;
  private channelSubscription: Subscription | null = null;
  showFromNumber = false;

  constructor() {
    super(NODE_TYPE);
  }

  ngOnInit(): void {
    this.optOut = new OptOut();
  }

  ngOnDestroy(): void {
    if (this.channelSubscription) {
      this.channelSubscription.unsubscribe();
    }
  }

  set buildForm(stepData: any) {
    this.formGroup = this.optOut.toForm(stepData, this.canEdit);
    this.setAllNextStepValues = ['success', 'error'];

    const initialChannel = this.formGroup.get('channel')?.value;
    this.showFromNumber = initialChannel === 'WHATSAPP';

    this.channelSubscription = this.formGroup.get('channel')?.valueChanges.subscribe(channel => {
      this.showFromNumber = channel === 'WHATSAPP';
      const fromNumberControl = this.formGroup.get('fromNumber');

      if (channel === 'WHATSAPP') {
        fromNumberControl?.setValidators(required('fromNumber'));
      } else {
        fromNumberControl?.clearValidators();
        // Clear value when not visible
        fromNumberControl?.setValue(null);
      }
      fromNumberControl?.updateValueAndValidity();
    });

    // Set initial validators
    if (initialChannel === 'WHATSAPP') {
      this.formGroup.get('fromNumber')?.setValidators(required('fromNumber'));
      this.formGroup.get('fromNumber')?.updateValueAndValidity();
    }
  }

  get getStepData(): {} {
    this.optOut.setNodeData(this.formGroup.getRawValue());
    return this.optOut.nodeData;
  }

  get isNodeValid(): boolean {
    return this.isValidateForm();
  }

}
